// selectors/registration.ts
import { createSelector } from '@reduxjs/toolkit';

// If you have a RootState type, import it, or declare it here:
import type { RootState } from '@/store/rootReducer';
import type { RegistrationState } from '@/types/Registration';

// Root selector
export const selectRegistration = (state: RootState): RegistrationState => state.registration;

// Select individual fields
export const selectRegistrationData = createSelector(
  selectRegistration,
  reg => reg.data
);
